import {momentDateFormatter} from "../Util/MomentDateFormatter";

export const setStartDateFilter = (startDate) => {
    return momentDateFormatter.formatStartOfDay(startDate)
};

export const setEndDateFilter = (endDate) => {
    return momentDateFormatter.formatEndOfDay(endDate)
};
